import React from "react";
import { IWebsiteAlert } from "./interfaces";
import ReactHtmlParser from "react-html-parser";

type showAlertState = {
  isModalOpen: boolean;
};

export default class ShowAlert extends React.Component<
  IWebsiteAlert,
  showAlertState
> {
  private ref = React.createRef<HTMLDialogElement>();
  constructor(props: IWebsiteAlert) {
    super(props);
  }

  componentDidMount() {
    this.ref.current.showModal();
  }

  render() {
    return (
      <dialog className="website-alert" ref={this.ref}>
        <div className="website-alert__icon form__popup-error-icon">
          <span className="icon icon-cross"></span>
        </div>
        <div className="website-alert__title form__popup-content-text form__popup-ok-text">
          {ReactHtmlParser(this.props.title)}
        </div>
        <p className="website-alert__message">
          {ReactHtmlParser(this.props.message)}
        </p>
        <button
          onClick={() => this.ref.current.close()}
          className="website-alert__button btn btn-outline-primary"
        >
          {this.props.buttonText}
        </button>
      </dialog>
    );
  }
}
